import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import CheckIcon from '@mui/icons-material/Check'
import {LoadingButton} from '@mui/lab'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import {Trans, useTranslation} from 'react-i18next'

interface SaveKilnDialogProps {
  open: boolean
  loading: boolean
  isValid: boolean
  onClose: () => void
  handleSubmit: () => void
}

export const SaveKilnDialog: React.FC<SaveKilnDialogProps> = ({
  open,
  loading,
  isValid,
  onClose,
  handleSubmit
}) => {
  const {t} = useTranslation()

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle typography="h3">
        {isValid ? t('kilnConfig.saveValidKilnTitle') : t('kilnConfig.saveNotValidKilnTitle')}
      </DialogTitle>
      <DialogContent>
        {!isValid && (
          <DialogContentText component={Alert} severity="error">
            <Trans i18nKey="kilnConfig.saveNotValidKilnContent" />
          </DialogContentText>
        )}
        {isValid && (
          <DialogContentText component={Alert} severity="warning">
            {t('kilnConfig.saveValidKilnContent')}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="text"
          startIcon={<ArrowBackIosIcon />}
          data-test-id="back-to-setup-btn"
        >
          {t('kilnConfig.backToSetup')}
        </Button>
        {isValid && (
          <LoadingButton
            onClick={handleSubmit}
            variant="text"
            startIcon={<CheckIcon />}
            loading={loading}
            loadingPosition="start"
            data-test-id="save-setup-btn"
          >
            {t('kilnConfig.save')}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  )
}
